// extracted by mini-css-extract-plugin
export var connectedProductsSectionWrapperStyle = "case_study_hero_connected_products-module--connectedProductsSectionWrapperStyle--nvx7J";
export var connectedProductsTagsWrapperStyle = "case_study_hero_connected_products-module--connectedProductsTagsWrapperStyle--7qTK2";